export default __webpack_public_path__ + "images/ND.d6af8ad.png";